import { render, staticRenderFns } from "./ClientPersons.vue?vue&type=template&id=dbf6cb56&scoped=true&"
import script from "./ClientPersons.vue?vue&type=script&lang=js&"
export * from "./ClientPersons.vue?vue&type=script&lang=js&"
import style0 from "./ClientPersons.vue?vue&type=style&index=0&id=dbf6cb56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf6cb56",
  null
  
)

export default component.exports